/**
 * Error type for the generated openapi-fetch client.
 *
 * openapi-fetch returns `{ data, error, response }` instead of throwing. `unwrap`
 * collapses that to data-or-throw so React Query sees a real error and query
 * factories stay one-liners.
 *
 * `getErrorMessage` (in @billda/shared-ui) has a branch that reads `.body` off an
 * ApiError, so backend `{ message }` bodies produce the same user-facing text they
 * did when the client threw AxiosError.
 */
export class ApiError extends Error {
  status: number;
  body: unknown;

  constructor(status: number, body: unknown) {
    super(`API error ${status}`);
    this.name = 'ApiError';
    this.status = status;
    this.body = body;
  }
}

/**
 * Collapse an openapi-fetch `{ data, error, response }` result to its data, or
 * throw an ApiError carrying the response status and error body.
 *
 * A successful empty-body response (204 / Content-Length 0) has `data ===
 * undefined` yet `response.ok`, so `data` alone can't signal failure. Gate on
 * `response.ok`: return `data` (possibly `undefined`) on success, throw only
 * when the response is not ok.
 */
export function unwrap<T>(result: {
  data?: T;
  error?: unknown;
  response: Response;
}): T {
  if (!result.response.ok) {
    throw new ApiError(result.response.status, result.error);
  }
  return result.data as T;
}
